export const getIsMobile = () => {
  if (typeof window === 'undefined') {
    return undefined;
  } else {
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  }
};
export default getIsMobile;
